<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="orderList">我的订单</span>
    </nav-bread>
    <div class="container">
      <el-container>
        <div class="biaot"><p class="mshow">个人中心&nbsp;&nbsp;>&nbsp;&nbsp; 标本管理</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>
        <el-container style="margin:0 0 0 20px">
          <el-main id="SampleResult">
            <el-row>
              <el-col :span="24">
                <p>操作成功！</p>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-button @click="toOrderDesc">查看订单</el-button>
              </el-col>
            </el-row>
            <!--<el-row>-->
              <!--<el-col :span="24">-->
                <!--<el-button @click="toSampleManage">查看样本</el-button>-->
              <!--</el-col>-->
            <!--</el-row>-->
            <el-row v-if="sampleInput">
              <el-col :span="24">
                <el-button @click.native.prevent="addOrUpdateHandle">修改样本</el-button>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-container>
    </div>

    <!--样本信息弹框-->
    <sample-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate"></sample-add-or-update>
  </div>

</template>

<script>
  import axios from 'axios'
  import NavHeader from '@/components/Header.vue'
  import NavFooter from '@/components/Footer.vue'
  import NavBread from '@/components/Bread.vue'
  import NavLeft from '@/components/NavLeft.vue'
  import SampleAddOrUpdate from '../../components/sample-add-or-update'
  import { getCookie } from "../../util/util";

  export default {
    name: "sample-result",
    data() {
      return {
        orderId:this.$route.query.orderId,
        orderNum:this.$route.query.orderNum,
        detailItemId:this.$route.query.detailItemId,
        itemId:this.$route.query.itemId,
        sampleInput:true,
        p_activeIndex: '6',
        p_showSearch:true,
        p_loginModalFlag:false,
        addOrUpdateVisible: false
      }
    },
    components: {
      NavHeader,
      NavFooter,
      NavBread,
      NavLeft,
      SampleAddOrUpdate
    },
    mounted () {
      // this.init()
    },
    methods: {
      p_showLoginModal(){
        this.p_loginModalFlag = true
      },

      p_closeLoginModal(){
        this.p_loginModalFlag = false
      },

      init () {
        axios.get("/jys/orderSample/hosp/" + this.detailItemId
        ).then((res) => {
          if(res.data.code == 0){
            if(res.data.orderSample.sampleStatus === 2){
              this.sampleInput = false
            }
          }
        })
      },

      //查看订单
      toOrderDesc () {
        this.$router.push({path: "/mine/orderDesc", query: {id: this.orderId, orderType : 1}})
      },

      //查看样本
      // toSampleManage () {
      //   this.$router.push({path: "/mine/sampleManage", query: {orderNum: this.orderNum}})
      // },

      //录入标本
      addOrUpdateHandle () {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init('',this.detailItemId,this.itemId,this.orderId)
        })
      }
    }
  }
</script>

<style scoped>
  #SampleResult{
    text-align: center;
  }
  #SampleResult .el-row{
    margin-bottom: 26px;
  }
  #SampleResult .el-row:first-child{
    margin:20px 0 76px 0;
    color: #393E46;
    font-size: 22px;
  }
  .el-button{
    color: #000000;
    border-color: #979797;
    width: 15%;
    min-width: 150px;
  }
  .mshow{
    display: none;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .userInfo {
      height: 80px;
      margin: 0;
    }

    .mshow {
      display: block;
    }
    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }
    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }
    /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel{
      display: none!important;
    }
    /deep/ .out {
      color: rgba(0, 196, 170, 1);
      padding-left: 0;
      margin-right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/sample/sample-result.vue